import { useState } from "react";

export default function SearchableMultiSelect({
  label,
  items,
  selected,
  onSelect,
  onRemove,
  placeholder,
  disabled,
}) {

  const [query, setQuery] = useState("");

  const filtered = items.filter((item) =>
    item.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="flex flex-col">
      <label className="text-sm font-medium text-slate-700 mb-1">
        {label}
      </label>

      {/* Search input */}
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder || "Search..."}   // 🔥 HERE
        disabled={disabled}
        className="w-full px-3 py-2 border rounded-lg text-sm"
        />


      {/* Dropdown list */}
      <div
        className="border rounded-lg bg-white max-h-40 overflow-y-auto"
      >
        {filtered.length === 0 && (
          <p className="text-xs text-slate-500 p-2">
            No results found
          </p>
        )}

        {filtered.map((item) => (
          <div
            key={item}
            onClick={() => onSelect(item)}
            className={`px-3 py-2 text-sm cursor-pointer hover:bg-blue-50 ${
              selected.includes(item) ? "bg-blue-100" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      {/* Selected tags */}
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {selected.map((item) => (
            <span
              key={item}
              className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs flex gap-2 items-center"
            >
              {item}
              <button
                type="button"
                onClick={() => onRemove(item)}
                className="text-red-600 font-bold"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
